import { BebopUser } from 'src/app/interfaces/user';

export interface CreateUserProfileDataArgs {
  userId: string;
  form: {
    firstname?: string;
    lastname?: string;
    gender?: string;
    birthdate?: string | Date;
    parental_approval?: boolean;
    business_name?: string;
    business_kvk?: string;
    referral_type?: string;
    referral_code?: string;
    referral_social?: string;
    referral_website?: string;
    region_id?: string;
    register_as?: string;
  };
  locationId: string;
  timestamp: ReturnType<typeof import('firebase/firestore').serverTimestamp>;
  platform: string;
  userEmail: string | null;
  mobileStored: string;
  is_client: boolean;
  is_worker: boolean;
  dashboard: string;
  registrationSettings: { darkmode: boolean; language: 'nl' | 'en' };
}

export function buildCreateUserProfileData(args: CreateUserProfileDataArgs): Partial<BebopUser> {
  const {
    userId,
    form,
    locationId,
    timestamp,
    platform,
    userEmail,
    mobileStored,
    is_client,
    is_worker,
    dashboard,
    registrationSettings,
  } = args;

  return {
    app_state: 'foreground',
    uid: userId,
    firstname: form.firstname,
    lastname: form.lastname,
    gender: form.gender,
    email: userEmail ?? undefined,
    birthdate: form.birthdate ? new Date(form.birthdate) : null,
    parental_approval: form.parental_approval,
    business_name: form.business_name,
    business_kvk: form.business_kvk,
    referral_type: form.referral_type,
    referral_code: form.referral_code,
    referral_social: form.referral_social,
    referral_website: form.referral_website,
    mobile: mobileStored,
    mobile_verified: false,
    home_location_id: locationId,
    region_id: form.region_id,
    is_client,
    registration_step: 2,
    registration_state: 'phone_verification_pending',
    registration_state_updated_at: timestamp,
    registration_flow_version: 2,
    client_profile_saved: false,
    client_overdue_warnings_received: 0,
    is_worker,
    worker_profile_saved: false,
    worker_overdue_warnings_received: 0,
    dashboard,
    ...(platform === 'ios' || platform === 'android' ? { device_platform: platform } : {}),
    notification_id: '',
    notification_setting: 2,
    notification_interval: 1,
    is_active: false,
    is_banned: false,
    credits: 0,
    terms_agreed_to: '',
    terms_agreed_on: '',
    privacy_agreed_to: '',
    privacy_agreed_on: '',
    provision_agreed_to: '',
    provision_agreed_on: '',
    filters: 'jobs,errands,cleaning,pets,garden,other',
    setting_darkmode: registrationSettings.darkmode,
    setting_language: registrationSettings.language,
    created_at: timestamp,
  };
}
